module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0671.edc8b309.jpg";